import { render, staticRenderFns } from "./実態純資産.vue?vue&type=template&id=06f480d1&scoped=true&"
import script from "./実態純資産.ts?vue&type=script&lang=ts&"
export * from "./実態純資産.ts?vue&type=script&lang=ts&"
import style0 from "./実態純資産.css?vue&type=style&index=0&id=06f480d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f480d1",
  null
  
)

export default component.exports